module.exports = __webpack_public_path__ + "img/logo-batik-air.f844e678.png";